import { ApolloQueryResult, OperationVariables } from "apollo-client";
import {
  PageVisibilityProps,
  usePageVisibility,
} from "core/hooks/usePageVisibility";

/**
 * `usePageVisibilityPolling`:
 * See: https://www.apollographql.com/docs/react/api/react-hooks/
 * This example pattern leverages Apollo to only refetch when `changedFor` is greater than `pollInterval`.
 * This is a very nice compromise between the two default patterns, as you get real time updates but no greedy refetches / renders!
 */
export interface usePageVisibilityPollingProps {
  pollInterval: number;
  startPolling: (pollInterval: number) => void;
  stopPolling: () => void;
  refetch?: (variables?: any) => Promise<ApolloQueryResult<any>> | undefined;
  variables?: OperationVariables;
}

export const usePageVisibilityPolling = ({
  pollInterval,
  startPolling,
  stopPolling,
  refetch,
  variables = {},
}: usePageVisibilityPollingProps) =>
  usePageVisibility(({ isVisible, changedFor = 0 }: PageVisibilityProps) => {
    if (isVisible) {
      if (changedFor > pollInterval && refetch) refetch(variables);

      startPolling(pollInterval);
    } else stopPolling();
  });
